<div class="modal fade" id="dialogTrocarExercicio" tabindex="-1" role="dialog" aria-labelledby="autorizacao"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header bg-primary text-white">
        <h5 class="modal-title" id="title">Troca de exercício de trabalho</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form id="troca-exercicio-form">
          <div class="row">
            <div class="col-12">
              <span>Informe o exercício de trabalho.</span>
            </div>
          </div>
          <div class="row mt-3">
            <div class="form-group col-md-3">
              <label for="ano">Exercício</label>
              <select [compareWith]="compareFn" [(ngModel)]="exercicio" [ngModelOptions]="{standalone: true}" class="form-control custom-select">
                <option *ngFor="let item of listaExercicios" [ngValue]="item">{{item.ano}}</option>
              </select>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button (click)="enviar()" type="button" class="btn btn-primary btn-sm" id="btnEnviar"
          data-dismiss="modal">Enviar</button>
        <button type="button" class="btn btn-link" id="btnCancelar" data-dismiss="modal">Cancelar</button>
      </div>
    </div>
  </div>
</div>
